import './Accordion.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SECTION_ICON_STYLE } from '../SectionCard/sectionIconStyle';

// collapsible={false}: same panel look, but always open — plain header (no toggle, no chevron).
const Accordion = ({ id, parent, title, icon, count, children, defaultOpen = true, flush = false, collapsible = true }) => {
  const titleMain = (
    <span className="accordion-title-main">
      {icon && (
        <span className="accordion-title-icon" style={SECTION_ICON_STYLE}>
          <FontAwesomeIcon icon={icon} />
        </span>
      )}
      {title}
      {!!count && <span className="accordion-count">{count}</span>}
    </span>
  );

  return (
    <div className={`product-accordion accordion accordion-item${flush ? ' product-accordion--flush' : ''}`}>
      <h2 className="accordion-header">
        {collapsible ? (
          <button
            className={`accordion-button ${defaultOpen ? '' : 'collapsed'}`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${id}`}
            aria-expanded={defaultOpen}
            aria-controls={id}
          >
            {titleMain}
          </button>
        ) : (
          <div className="accordion-button accordion-button--static">
            {titleMain}
          </div>
        )}
      </h2>
      <div
        id={id}
        className={collapsible ? `accordion-collapse collapse ${defaultOpen ? 'show' : ''}` : undefined}
        aria-labelledby={id}
      >
        <div className="accordion-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
